module.exports = __webpack_public_path__ + "img/avatar-2.251d7309.png";